import React from 'react';
import { Paper, Stack } from '@mantine/core';
import ConfirmedBillingTable from '../components/table/ConfirmedBillingTable.tsx';
import BillingFilter from '../components/filter/BillingFilter.tsx';
import useConfirmedBillings from '../hooks/useConfirmedBillings.ts';
import { useBillingFilter } from '../hooks/useBillingFilter.tsx';
import { uniqueByKeys } from '../utils/array.ts';

export default function ConfirmedBillingPage() {
  const { isLoading, data = [] } = useConfirmedBillings();
  const { filteredData, handleFilter } = useBillingFilter(data);

  const siteProviders = uniqueByKeys(
    data.map((x) => x.siteProvider),
    ['id'],
  );
  const tags = [...new Set(data.flatMap((x) => x.tags.map((tag) => tag.name)))];

  return (
    <Paper p="xl" radius="lg" shadow="xl" mb="xl">
      <Stack gap="xl">
        <BillingFilter
          providers={siteProviders}
          tags={tags}
          onFilter={handleFilter}
        />
        <ConfirmedBillingTable data={filteredData} isLoading={isLoading} />
      </Stack>
    </Paper>
  );
}
